import {ContentBox} from 'mui-core';
import {Box, Divider, Stack, Typography} from '@mui/material';

export const DashBoardSection = ({children, title, icon, iconContainerSx}) => {
  return (
    <ContentBox variant="outlined">
      <Stack
        spacing={2}
        direction="row"
        alignItems="center"
        sx={{px: 3, py: 2}}>
        {icon && (
          <Box
            sx={{
              p: 1,
              borderRadius: '50%',
              display: 'inline-flex',
              boxShadow: `0 3px 14px 0 rgba(0, 0, 0, 0.08);`,
              ...iconContainerSx,
            }}>
            {icon}
          </Box>
        )}
        <Typography component="h3" variant="title-md-bold" color="text.primary">
          {title}
        </Typography>
      </Stack>
      <Divider />
      {children}
    </ContentBox>
  );
};
